import { Modal } from "@mui/material";
import Image from "next/image";
import Terms from "@/app/[lng]/(use-auth)/terms-and-conditions/terms";
import Close from "@/assets/images/icons/close.svg";
import CustomButton from "@/common/customElements/button";
import HexagonButton from "@/common/customElements/HexagonButton";
import { AbsoluteDiv, HorizontalCenterDiv } from "@/common/divs";
import { AlmostBoldText, RegularText } from "@/common/texts";
import { NEUTRO_TITLES_COLOR, PRIMARY_BUTTON_COLOR } from "@/utils/constants";
import "@/components/activity/activity.css";

interface ModalTermsAndConditionsProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  actionToDo: () => void;
  allowClosing?: boolean;
}

const ModalTermsAndConditions: React.FC<ModalTermsAndConditionsProps> = ({
  open,
  setOpen,
  actionToDo,
  allowClosing,
}) => {
  return (
    <Modal
      open={open}
      onClose={() => {
        allowClosing && setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div
        className="centerModal"
        style={{ height: "auto", width: "90%", maxWidth: "1200px" }}
      >
        {allowClosing ?
          <AbsoluteDiv right="24px" top="24px" style={{ zIndex: "9" }}>
            <HexagonButton
              onClick={() => {
                setOpen(false);
              }}
              width="32px"
              backgroundColor={PRIMARY_BUTTON_COLOR}
            >
              <Image
                alt="close"
                width="16"
                height="16"
                src={Close.src}
                style={{
                  position: "absolute",
                  top: "20%",
                  left: "27%",
                }}
              />
            </HexagonButton>
          </AbsoluteDiv>
        : <HorizontalCenterDiv style={{ flexDirection: "column" }}>
            <AlmostBoldText fontSize="24px">
              Hemos actualizado los términos y condiciones
            </AlmostBoldText>
            <RegularText>Por favor, acéptelos para continuar</RegularText>
          </HorizontalCenterDiv>
        }

        <Terms />
        <HorizontalCenterDiv paddingY="20px" style={{ gap: "20px" }}>
          <CustomButton
            onClick={() => {
              actionToDo();
            }}
            type="submit"
            width="250px"
            height="50px"
            backgroundColor={PRIMARY_BUTTON_COLOR}
          >
            <RegularText fontSize="18px" color={NEUTRO_TITLES_COLOR}>
              Aceptar y cerrar
            </RegularText>
          </CustomButton>
        </HorizontalCenterDiv>
      </div>
    </Modal>
  );
};
export default ModalTermsAndConditions;
